<template lang="pug">
  .container
    div(v-if="$route.query.code")
      h1 授權成功，請稍後
    div(v-if="$route.query.error")
      h1 授權失敗
      p(style="text-align: center; color: #666;") {{ $route.query.error }}
    .loading-animation
    //- pre {{ code }}
    //- pre {{ accessToken }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'callback',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.$route.query.code) {
        vm.code = vm.$route.query.code
      } else if (vm.$route.query.error) {
        vm.code = vm.$route.query.error
      }
      vm.fetchAccessToken(vm.code).then(function (data) {
        vm.accessToken = data
        window.localStorage.setItem('accessToken', 'Bearer ' + data.access_token)
      }).then(() => {
        window.close()
      })
    })
  },
  components: {
  },
  data () {
    return {
      code: '',
      accessToken: ''
    }
  },
  computed: {
    ...mapGetters(['getUser'])
  },
  methods: {
    ...mapActions([
      'fetchAccessToken'
    ])
  },
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
  .container
    margin-top: 50px
    h1
      text-align: center
</style>



// WEBPACK FOOTER //
// callback.vue?194c05a2